// Environment-based endpoint configuration
export const shippingLabelEndpointPrefix = process.env.REACT_APP_SHIPPING_LABEL_ENDPOINT;

// Derived Base URLs
export const API_BASE_URL = `${shippingLabelEndpointPrefix}`;
export const ECOMMERCE_API_BASE_URL = process.env.REACT_APP_ECOMMERCE_ENDPOINT || 'http://localhost:5003/api/ecommerce';

// Global Options
export const CURRENCY_OPTIONS = ['USD', 'CNY'] as const;

export const VENDOR_OPTIONS = [
  { value: 'datacube', label: 'datacube' },
  { value: 'its', label: 'its' },
  { value: 'jgwy', label: 'jgwy' },
  { value: 'hzm', label: 'hzm' },
  { value: 'gofo', label: 'gofo' }
];

export const PAGE_SIZE_OPTIONS = [20, 50, 100];
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE = 1;

// Export state options from constants
export { STATE_OPTIONS, US_STATE_ABBREVS } from './constants/states';
